/* Public YUNOVA product discovery. Do not import the internal operator-data.ts here.
   Manufacturer specifications are not proof of procurement, deployment, or availability. */
export type PublicLang = 'zh' | 'en';
export type Pair = { zh: string; en: string };
export const pair = (zh: string, en: string): Pair => ({ zh, en });
export const tr = (value: Pair, lang: PublicLang) => value[lang];

export type PublicGpu = {
  id: string;
  title: string;
  level: Pair;
  memoryGbPerGpu: number;
  memoryType: string;
  nodeConfiguration: Pair;
  workloads: Pair;
  deployment: Pair;
  tags: ('training' | 'tuning' | 'inference')[];
  manufacturerSource: string;
  sourceUpdatedAt: string;
  supplyStatus: 'unverified';
  publicVisibility: 'selection-reference';
  price: null;
  billingUnit: null;
  inventory: null;
  deploymentRegion: null;
};

export const publicGpus: PublicGpu[] = [
  {
    id: 'h100-sxm', title: 'NVIDIA H100 SXM',
    level: pair('單顆 GPU 規格；HGX 伺服器配置另議', 'Per-GPU specification; HGX server configuration separately scoped'),
    memoryGbPerGpu: 80, memoryType: 'HBM3',
    nodeConfiguration: pair('HGX 夥伴系統可為 4 或 8 GPU；實際節點須確認', 'HGX partner systems support 4 or 8 GPUs; actual node subject to confirmation'),
    workloads: pair('模型訓練、微調與推論評估', 'Model training, fine-tuning and inference evaluation'),
    deployment: pair('專用 GPU 節點或叢集，依供應條件洽談', 'Dedicated GPU node or cluster, subject to supply review'),
    tags: ['training', 'tuning', 'inference'],
    manufacturerSource: 'https://www.nvidia.com/en-us/data-center/h100/', sourceUpdatedAt: '2026-10-05',
    supplyStatus: 'unverified', publicVisibility: 'selection-reference',
    price: null, billingUnit: null, inventory: null, deploymentRegion: null,
  },
  {
    id: 'h200-sxm', title: 'NVIDIA H200 SXM',
    level: pair('單顆 GPU 規格；HGX 伺服器配置另議', 'Per-GPU specification; HGX server configuration separately scoped'),
    memoryGbPerGpu: 141, memoryType: 'HBM3e',
    nodeConfiguration: pair('HGX 夥伴系統可為 4 或 8 GPU；實際節點須確認', 'HGX partner systems support 4 or 8 GPUs; actual node subject to confirmation'),
    workloads: pair('大模型訓練、微調與高記憶體推論', 'Large-model training, fine-tuning and memory-intensive inference'),
    deployment: pair('專用 GPU 節點或叢集，依供應條件洽談', 'Dedicated GPU node or cluster, subject to supply review'),
    tags: ['training', 'tuning', 'inference'],
    manufacturerSource: 'https://www.nvidia.com/en-us/data-center/h200/', sourceUpdatedAt: '2026-10-05',
    supplyStatus: 'unverified', publicVisibility: 'selection-reference',
    price: null, billingUnit: null, inventory: null, deploymentRegion: null,
  },
  {
    id: 'hgx-b300', title: 'NVIDIA HGX B300',
    level: pair('HGX 八卡參考平台；記憶體數字為每顆 B300 GPU', 'HGX eight-GPU reference platform; memory shown is per B300 GPU'),
    memoryGbPerGpu: 288, memoryType: 'HBM3e',
    nodeConfiguration: pair('NVIDIA HGX B300 參考架構為 8 GPU／節點；OEM 實配待確認', 'NVIDIA HGX B300 reference architecture has 8 GPUs/node; OEM configuration to verify'),
    workloads: pair('大型模型訓練與高吞吐推論的規劃評估', 'Planning evaluation for large-model training and high-throughput inference'),
    deployment: pair('HGX 整機及專用叢集，需另行核對設備供應', 'HGX system and dedicated cluster; equipment sourcing must be verified'),
    tags: ['training', 'inference'],
    manufacturerSource: 'https://docs.nvidia.com/enterprise-reference-architectures/hgx-ai-factory/latest/components.html', sourceUpdatedAt: '2026-10-05',
    supplyStatus: 'unverified', publicVisibility: 'selection-reference',
    price: null, billingUnit: null, inventory: null, deploymentRegion: null,
  },
];

export const byGpuId = (id: string | null) => publicGpus.find(g => g.id === id);
export const trackPublicEvent = (name: 'gpu_select' | 'inquiry_intent', fields: Record<string, string>) => {
  try {
    (window as typeof window & { umami?: { track: (event: string, data: Record<string, string>) => void } }).umami?.track(name, fields);
  } catch { /* Analytics never blocks public navigation. No form field or PII is sent. */ }
};
